import {useEffect} from "react"
import checkPageSizeLimit from "../../utils/checkPageSizeLimit"

export const useCheckPageSizeLimit = (pageSizeLimit: number) => {
    useEffect(() => {
        checkPageSizeLimit(pageSizeLimit)
    }, [pageSizeLimit])
}
